module.exports = __webpack_public_path__ + "7e4b29ba/img/scraper-icon.df6ccde5.svg";